/**
 * ────────────────────────────────────────────────────────────────────────────
 * UI KIT — punto de importación único
 * ────────────────────────────────────────────────────────────────────────────
 * Importá SIEMPRE desde acá:
 *
 *   import { Button, Card, Badge, VerificationBadge, Avatar, Input } from "@/components/ui";
 *
 * Los íconos de línea viven en "@/components/ui/icons" (importalos de ahí).
 */
export { Button, type ButtonProps } from "./Button";
export { Card, CardTitle, CardBody, type CardProps } from "./Card";
export {
  Badge,
  VerificationBadge,
  SessionStateBadge,
  type BadgeProps,
} from "./Badge";
export { Avatar, type AvatarProps } from "./Avatar";
export { Input, type InputProps } from "./Input";
export { Select, type SelectProps, type SelectOption } from "./Select";
export { Tabs, type TabsProps, type TabItem } from "./Tabs";
export { EmptyState } from "./EmptyState";
export { PageHeader } from "./PageHeader";
export { BottomNav, type BottomNavItem } from "./BottomNav";
export { Slot } from "./Slot";
